var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: 405.156,
    x2: 313.247,
    y1: -41.241,
    y2: 205.402,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "e",
    x1: 410.946,
    x2: 243.393,
    y1: 318.933,
    y2: 151.381,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "f",
    x1: 282.329,
    x2: 152.183,
    y1: 112.322,
    y2: -17.824,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 258.062,
    x2: 258.062,
    y1: -99.307,
    y2: 390.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "h",
    x1: 482.845,
    x2: 355.366,
    y1: 248.203,
    y2: 236.153,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "i",
    x1: 281.026,
    x2: 162.568,
    y1: 111.019,
    y2: -7.44,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 213.168,
    x2: 213.168,
    y1: 10.315,
    y2: 62.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#fd4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#f93867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f12358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#e60642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "k",
    x1: 234.363,
    x2: 234.363,
    y1: 197.447,
    y2: 408.537,
    gradientUnits: "userSpaceOnUse"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#ffcb0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#ffa215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    x1: 405.156,
    x2: 313.247,
    y1: -41.241,
    y2: 205.402,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9517",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#ee8421",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#e07728",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db722b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "e",
    x1: 410.946,
    x2: 243.393,
    y1: 318.933,
    y2: 151.381,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "f",
    x1: 282.329,
    x2: 152.183,
    y1: 112.322,
    y2: -17.824,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 258.062,
    x2: 258.062,
    y1: -99.307,
    y2: 390.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8190a4",
    stopOpacity: 0.671
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "h",
    x1: 482.845,
    x2: 355.366,
    y1: 248.203,
    y2: 236.153,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "i",
    x1: 281.026,
    x2: 162.568,
    y1: 111.019,
    y2: -7.44,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 213.168,
    x2: 213.168,
    y1: 10.315,
    y2: 62.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228,
    stopColor: "#fd4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#f93867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#f12358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#e60642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "k",
    x1: 234.363,
    x2: 234.363,
    y1: 197.447,
    y2: 408.537,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(\"#d\")",
    d: "M476.703 386.633H137.305c-8.977 0-16.254-7.278-16.254-16.254V43.32C121.05 19.395 140.445 0 164.37 0H468.68C492.605 0 512 19.395 512 43.32v308.016c0 19.496-15.8 35.297-35.297 35.297zm0 0",
    opacity: 1,
    "data-original": "url(#d)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(\"#e\")",
    d: "M137.305 386.633h339.398c19.496 0 35.297-15.805 35.297-35.297V71.98l-33.754-33.753c-5.512-6.153-13.516-10.028-22.426-10.028H123.77a43.218 43.218 0 0 0-2.72 15.121V370.38c0 8.976 7.278 16.254 16.255 16.254zm0 0",
    opacity: 1,
    "data-original": "url(#e)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(\"#f\")",
    d: "M139.395 31.629c5.976 18.758 23.402 31.492 43.09 31.492h120.023c-1.586 0-3.156-.09-4.711-.254L249.07 14.172C240.723 5.414 229 .137 216.332.137h-51.086c-13.809 0-26.168 6.199-34.46 15.957a45.143 45.143 0 0 1 8.609 15.535zm0 0",
    opacity: 1,
    "data-original": "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(\"#g\")",
    d: "M455.82 386.633H60.305c-16.625 0-30.102-13.477-30.102-30.102V58.297c0-16.625 13.477-30.102 30.102-30.102H455.82c16.625 0 30.102 13.477 30.102 30.102V356.53c0 16.625-13.477 30.102-30.102 30.102zm0 0",
    opacity: 1,
    "data-original": "url(#g)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(\"#h\")",
    d: "M444.031 77.309c-8.242-8.73-19.918-14.188-32.875-14.188H30.203v293.41c0 16.625 13.477 30.102 30.102 30.102H455.82c16.625 0 30.102-13.477 30.102-30.102V119.2zm0 0",
    opacity: 1,
    "data-original": "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(\"#i\")",
    d: "M139.395 31.629c5.976 18.758 23.402 31.492 43.09 31.492h120.023c-1.586 0-3.156-.09-4.711-.254l-34.692-34.672H138.133c.46 1.125.89 2.262 1.262 3.434zm0 0",
    opacity: 1,
    "data-original": "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(\"#j\")",
    d: "M306.309 74.523V63.121h-3.801c-19.684 0-37.11-12.734-43.086-31.492C253.445 12.87 236.02.137 216.332.137h-51.086c-24.973 0-45.223 20.246-45.223 45.222v29.164zm0 0",
    opacity: 1,
    "data-original": "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(\"#k\")",
    d: "M139.395 31.629C133.418 12.87 115.992.137 96.309.137H45.223C20.246.137 0 20.383 0 45.359v296.614c0 24.664 19.996 44.66 44.66 44.66h424.067c-6.82 0-12.348-5.528-12.348-12.348V108.344c0-24.973-20.246-45.223-45.223-45.223H182.484c-19.687 0-37.113-12.734-43.09-31.492zm0 0",
    opacity: 1,
    "data-original": "url(#k)",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFile);
export default __webpack_public_path__ + "static/media/defaultFile.fc48907ffdd197dac069364fe4d5422b.svg";
export { ForwardRef as ReactComponent };